<script>

</script>

<!-- THE HTML -->
<h1>Tasker</h1>
<h3>Things redefined.</h3>
<h4>built with ❤ and Svelte.js</h4>

<!-- THE CSS -->
<style>
h1 {
		color: var(--contrast-clr-2);
		font-size: 6em;
		font-weight: 100;
		margin: 0 0 10px;
	}

	h3{
		color: var(--contrast-clr-1);
		font-size: 2em;
		font-weight: 100;
		margin: 10px 0 3px;
	}
	h4{
		color: var(--contrast-clr-1);
		font-weight: 400;
		font-size: small;
		margin-top: 0.5rem;
	}
	
</style>